import { useDispatch } from 'react-redux'

import { useNavigate } from 'react-router-dom'
import { clearUser } from '../features/api/user/userSlice'
import { apiSlice } from '../features/api/apiSlice'

const useLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const logout = () => {
    // 1. Clear Redux state
    dispatch(clearUser())

    // 2. Clear localStorage
    localStorage.removeItem('supplyCornerBackOfficeUser')

    // 3. Clear cookies (if needed)
    document.cookie.split(';').forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
    })

    // 4. Reset RTK Query API cache
    dispatch(apiSlice.util.resetApiState())

    // 5. Redirect
    navigate('/')
  }

  return logout
}

export default useLogout
